<template>
  <a v-if="visible"
    :href="trial ? learnmore_url : plansPage"
    @click="sendEvent"
    :data-testid="testid"
    target="_blank" class="pro-badge"><img width="14" src="@img/icon-padlock.svg" /><span class="pro-badge-text">Pro</span></a>
</template>

<script>
import track from "@/src/tracking";

export default {
  props: {
    utm_campaign: { type: String },
    utm_source: { type: String },
    utm_medium: { type: String },
    learnmore_url: { type: String },
    trial: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  computed: {
    plansPage: function() {
      return `/plans?utm_campaign=${this.utm_campaign}&utm_source=${this.utm_source}&utm_medium=${this.utm_medium}`;
    },
    testid: function() {
      return `pro-badge-${this.utm_medium}`;
    },
  },
  methods: {
    sendEvent: function() {
      const properties = {
        utm_campaign: this.utm_campaign,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
      };
      track("pro_badge_clicked", properties);
    },
  },
};
</script>

<style scoped lang="scss">
@import "application.scss";

.pro-badge {
  background: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
  color: $white !important;
  padding: 0rem 0.5rem !important;
  border-radius: 1rem;
  font-size: 0.9rem;
  margin: 0;
}


.pro-badge{
  border: 2px solid #0000;
  border-radius: 27px;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(89.93deg, #e68c47 3.67%, #ea6a5b 92.9%) border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.7rem;
  margin: 0 0 0 0.7rem;
  height: 22px;
}
.pro-badge-text {
  background: linear-gradient(89.93deg, #e68c47 3.67%, #ea6a5b 92.9%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-size: 16px;
}
.pro-badge:hover {
  color: $white;
  text-decoration: none;
}
</style>
